/**
 * @generated SignedSource<<ad3a313f762c4605692fda99cb12a006>>
 * @relayHash 1cf5e269ea7ab21dd29830f41cc30471
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 20eef186f5bb28ce94afb25c2e89d7bd8b74a953d39ebd3c1dd60d6420cbf484

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ProjectDirectoryLayoutQuery } from './ProjectDirectoryLayoutQuery.graphql';

import isAllowingEndUsersToAccessCustomTemplates_provider from '@atlassian/jira-relay-provider/src/jira-custom-template-allow-end-users-to-create-custom-templates.relayprovider';

const node: PreloadableConcreteRequest<ProjectDirectoryLayoutQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "20eef186f5bb28ce94afb25c2e89d7bd8b74a953d39ebd3c1dd60d6420cbf484",
    "metadata": {},
    "name": "ProjectDirectoryLayoutQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider": isAllowingEndUsersToAccessCustomTemplates_provider
    }
  }
};

export default node;
